import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../components/SEO';
import Layout from '../layouts/index';
import ReactPlayer from 'react-player';
import { Link } from 'react-scroll'
import HtmlParser from 'html-react-parser';

//import Modal from 'react-bootstrap/Modal';
//import Button from 'react-bootstrap/Button';
//import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import { DemoFormLong } from '../components/DemoFormLong.jsx';

import { DemoFormLongc19support} from '../components/DemoFormLongc19support.jsx';
import JoinHappyCustomers from '../components/JoinHappyCustomers';
const Home = (props) => {
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;

    return (
        <Layout bodyClass="page-home covid-support" ontouchstart>
            <SEO title="Supporting you through these times | ChartHop" />
            <Helmet>
                <meta
                    name="description"
                    content="Supporting you through these times. Increase productivity and belonging while decreasing operational burden. Build plans for any and all business scenario."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Supporting you through these times | ChartHop" />
                <meta property="og:description" content="Supporting you through these times. Increase productivity and belonging while decreasing operational burden. Build plans for any and all business scenario." />
                <meta property="og:image" content={`https://www.charthop.com/home/meta-home.gif`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Supporting you through these times | ChartHop" />
                <meta name="twitter:description" content="Supporting you through these times. Increase productivity and belonging while decreasing operational burden. Build plans for any and all business scenario." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/meta-home.gif`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>

            {/* PAGE CONTENT */}

            <section className="intro container">
                <div>
                    <h1>Supporting you through these times</h1>
                    <p className="pt-1">Increase productivity and belonging while decreasing operational burden. Build plans for any business scenario.</p>
                </div>
                <div className="row align-items-center">                    
                    <div className="reactPlayerContainer col-md-6 padding-top-video-one" >
                        <ReactPlayer
                            url="/landings/all-in-one.mp4"
                            playing
                            loop
                            muted
                            playsinline
                        />
					</div>
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pl-md-2 pl-lg-4">
                        <div className="headerLongForm">
                            <DemoFormLongc19support />
                        </div>                        
                    </div>
                </div>
            </section>   

            {/* THE SOLUTION */}
            <section className="the-solution">
                <div className="container pt-3 pt-md-5 pb-5 pb-md-8 pt-md-8 pb-lg-11">

                    {/* ANCHORS */}
                    <div className="row align-items-center mb-2 mb-md-5 mb-lg-5">
                        <div className="col-md-12 text-center">
                            <div className="d-flex justify-content-between justify-content-sm-center">
                                <Link to="Visualize" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Automagical Org Chart</Link>
                                <Link to="Plan" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Map Remote Workers</Link>
                                <Link to="Understand" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Scenario Planning</Link>
                            </div>
                        </div>
                    </div>

                    {/* ORG CHART */}
                    <div name="Visualize" id="Visualize" className="row align-items-center pb-3 pb-md-4 pb-lg-5 pt-3 pt-mt-4 pt-lg-5">

                        <div className="col-md-7 col-lg-6 order-md-2">
                            <div className="mr-md-2 ml-md-2 mr-lg-4 ml-lg-4">
                                <p className="minorBlueHeader">AUTOMAGICAL ORG CHART</p>
                                <h2 className="stillH1">Give every employee the context they need.  </h2>
                                <p>An org chart that builds (and updates!) itself, without any manual work or human error.</p>
                                <p>Enhance <strong>new hire onboarding</strong>,<strong> workforce productivity</strong> and <strong> employee belonging</strong> by giving everyone a clear understanding of who does what and how they fit within the greater organization.</p>
                            </div>

                        </div>

                        <div className="reactPlayerContainer col-md-5 col-lg-6 order-md-1" >
                            {/* <LazyLoad height={200} offset={100}  once={true}> */}
                            <ReactPlayer
                                url='/home/integration_home.mp4'

                                playing
                                loop
                                muted
                                playsinline
                            />
                            {/* </LazyLoad> */}
                        </div>

                    </div>

                    {/* PLAN */}
                    <div name="Plan" id="Plan" className="row align-items-center pb-3 pb-md-4 pb-lg-5 pt-3 pt-mt-4 pt-lg-5">
                        <div className="col-md-7 col-lg-6">
                            <div className="mr-md-2 ml-md-2 mr-lg-4 ml-lg-4">
                                <p className="minorBlueHeader">MAP REMOTE WORKERS</p>

                                <h2 className="stillH1">Know where your team is working from.</h2>
                                <p>Visualize your remote workforce on the map, while maintaining employee privacy.</p>
                                <p>Develop <strong> contingency plans </strong> as local ordinances are issued, business hours vary due to changes in time zones or school closures, and hot spots develop in metro areas.</p>

                                <p>Plus, send care packages to affected employees! </p>
                            </div>
                        </div>

                        <div className="reactPlayerContainer col-md-5 col-lg-6" >
                            <img src={'/blog/blog-covid-response/Map_HomeAddress_Detail.png'} alt="Remote workforce map" />
                            {/* <LazyLoad height={200} offset={100}  once={true}> */}

                            {/* </LazyLoad> */}
                        </div>
                    </div>

                    {/* Analysis */}
                    <div name="Understand" id="Understand" className="row align-items-center pt-3 pt-mt-4 pt-lg-5">

                        <div className="col-md-7 col-lg-6 order-md-2">
                            <div className="mr-md-2 ml-md-2 mr-lg-4 ml-lg-4">
                                <p className="minorBlueHeader">SCENARIO PLANNING</p>
                                <h2 className="stillH1">Design and measure the impact of org changes.</h2>
                                <p>Build alternate hiring plans, new team structures, proposed M&amp;A outcomes, department-specific changes, org-wide compensation plans, and more. </p>
                                <p> Track every proposed change and understand the <strong> impact </strong> in your structure, headcount and budget. </p>
                            </div>
                        </div>

                        <div className="reactPlayerContainer col-md-5 col-lg-6 order-md-1" >
                            {/* <LazyLoad height={200} offset={100}  once={true}> */}
                            <ReactPlayer
                                url='/landings/Scenario_RemoveOpenRole1.mp4'
                                playing
                                loop
                                muted
                                playsinline
                            />
                            {/* </LazyLoad> */}
                        </div>
                    </div>
                </div>
            </section>

            
			<section className="customer testimonial-container pt-8 pb-5">
                 <JoinHappyCustomers title={HtmlParser('Supporting these <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
            </section>



            {/* CONTACT FORM */}

            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={HtmlParser("c19supportbottom")} headertext={HtmlParser("<h2 className='stillH1'>We'll get through this, together.<br>--<br>Request a demo to learn more about how we can help.</h2>")}/>
            </section>


        </Layout>
    );
};


export default Home;


export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;